// Supported languages configuration
interface Language {
  code: string;
  name: string;
  nativeName: string;
  flag: string;
  isDefault: boolean;
  isEnabled: boolean;
}

const languages: Language[] = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇬🇧',
    isDefault: true,
    isEnabled: true,
  },
  {
    code: 'sv',
    name: 'Swedish',
    nativeName: 'Svenska',
    flag: '🇸🇪',
    isDefault: false,
    isEnabled: true,
  },
  // Future languages
  {
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch',
    flag: '🇩🇪',
    isDefault: false,
    isEnabled: false,
  },
  {
    code: 'hr',
    name: 'Croatian',
    nativeName: 'Hrvatski',
    flag: '🇭🇷',
    isDefault: false,
    isEnabled: false,
  },
];

export const enabledLanguages = languages.filter((lang) => lang.isEnabled);
export const defaultLanguage = languages.find((lang) => lang.isDefault) || languages[0];
export const languageCodes = enabledLanguages.map((lang) => lang.code);

export const getLanguageByCode = (code: string): Language | undefined => {
  return languages.find((lang) => lang.code === code);
};

export const isValidLanguage = (code: string): boolean => {
  return enabledLanguages.some((lang) => lang.code === code);
};
